import styled from "styled-components";

export const ChartWrapper = styled.div`
  width: 100%;

  .highcharts-contextbutton {
    .highcharts-button-box {
      fill-opacity: 0;
      fill: ${({ theme }) => theme.colors.primaryLightFill};
      rx: 14;
      ry: 14;
    }
    .highcharts-button-symbol {
      fill: ${({ theme }) => theme.colors.primarySeparator};
      stroke: ${({ theme }) => theme.colors.primarySeparator};
      stroke-width: 1.5px;
      transform: translateX(2px);
    }

    &:hover,
    &.highcharts-button-pressed {
      .highcharts-button-symbol {
        stroke: ${({ theme }) => theme.colors.primaryBackgroundSelected};
      }

      .highcharts-button-box {
        fill-opacity: 1;
      }
    }
  }

  .highcharts-contextmenu {
    font-family: Roboto !important;
    font-size: 12px !important;

    .highcharts-menu {
      box-shadow:
        0px 16px 24px 0px rgba(161, 153, 194, 0.24),
        0px 12px 20px 0px rgba(161, 153, 194, 0.24),
        0px 8px 16px 0px rgba(161, 153, 194, 0.2),
        0px 4px 8px 0px rgba(161, 153, 194, 0.16),
        0px 2px 4px 0px rgba(161, 153, 194, 0.12),
        0px 1px 2px 0px rgba(161, 153, 194, 0.08) !important;
      background: ${({ theme }) => theme.colors.neutralsWhite} !important;
      border-radius: 4px !important;

      .highcharts-menu-item {
        color: ${({ theme }) => theme.colors.primaryText} !important;
        font-weight: 400 !important;
      }

      hr {
        border-color: #a199c226;
      }
    }
  }

  .highcharts-title {
    color: ${({ theme }) => theme.colors.neutralsText} !important;
    fill: ${({ theme }) => theme.colors.neutralsText} !important;
    font-family: Roboto !important;
    font-size: 20px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: 24px !important;
  }

  .highcharts-background {
    fill-opacity: 0;
  }

  .highcharts-tooltip-box {
    fill: ${({ theme }) => theme.colors.neutralsText};
    fill-opacity: 0;
  }

  .highcharts-tooltip {
    background-color: ${({ theme }) => theme.colors.neutralsText};

    .highcharts-tooltip-custom-heading {
      background-color: ${({ theme }) => theme.colors.neutralsText};
    }

    .highcharts-tooltip-custom-heading-tr {
      background: ${({ theme }) => theme.colors.neutralsText};
      opacity: 0.85;

      .highcharts-tooltip-custom-heading-td {
        padding: 8px 16px;
        color: ${({ theme }) => theme.colors.neutralsWhite};
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
      }
    }

    .highcharts-tooltip-custom-point-tr {
      background: ${({ theme }) => theme.colors.neutralsText};
      opacity: 0.72;
      color: ${({ theme }) => theme.colors.neutralsWhite};
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;

      .highcharts-tooltip-custom-point-td-name {
        padding: 4px 2px 4px 16px;
      }

      .highcharts-tooltip-custom-point-td-value {
        padding: 4px 16px 4px 2px;
        font-weight: 600;
      }

      &:nth-child(2) {
        .highcharts-tooltip-custom-point-td-name {
          padding-top: 8px;
        }

        .highcharts-tooltip-custom-point-td-value {
          padding-top: 8px;
        }
      }

      &:last-child {
        .highcharts-tooltip-custom-point-td-name {
          padding-bottom: 8px;
        }

        .highcharts-tooltip-custom-point-td-value {
          padding-bottom: 8px;
        }
      }
    }

    .highcharts-tooltip-custom-table {
      color: ${({ theme }) => theme.colors.neutralsWhite};
      border-spacing: 0;
      border-collapse: separate;
      border-radius: 4px;
      border: 1px solid ${({ theme }) => theme.colors.neutralsText};
      overflow: hidden;
      box-shadow:
        0px 16px 24px 0px rgba(161, 153, 194, 0.24),
        0px 12px 20px 0px rgba(161, 153, 194, 0.24),
        0px 8px 16px 0px rgba(161, 153, 194, 0.2),
        0px 4px 8px 0px rgba(161, 153, 194, 0.16),
        0px 2px 4px 0px rgba(161, 153, 194, 0.12),
        0px 1px 2px 0px rgba(161, 153, 194, 0.08) !important;

      &,
      tr,
      td {
        border: 0;
      }
    }
  }
`;
